/**
 * Format a prize amount in the player's local currency.
 *  - Ghana → GHS 500
 *  - Nigeria → ₦50,000
 *  - Fallback → $X USD
 *
 * Accepts either a {amount, currency} prize object or null/undefined.
 */
export function formatPrize(prize, country) {
  if (!prize || prize.amount == null) return "—";
  const { amount, currency } = prize;
  const num = typeof amount === "number" ? amount : Number(amount) || 0;
  const formatted = num.toLocaleString("en-US");
  if (currency === "GHS" || country === "GH") return `GHS ${formatted}`;
  if (currency === "NGN" || country === "NG") return `\u20A6${formatted}`; // naira sign
  return `$${formatted} ${currency || "USD"}`;
}

/** Season prize tiers per country — kept in sync with backend payouts.DEFAULT_PRIZE_TIERS. */
export const PRIZE_TIERS = {
  GH: { currency: "GHS", tiers: { 1: 500, 2: 300, 3: 200 } },
  NG: { currency: "NGN", tiers: { 1: 50000, 2: 30000, 3: 20000 } },
};

export function prizeForRank(country, rank) {
  const cfg = PRIZE_TIERS[country];
  if (!cfg) return null;
  const amount = cfg.tiers[rank];
  if (amount == null) return null;
  return { amount, currency: cfg.currency };
}
